import { Button, Form } from 'antd';
import { UploadFile } from 'antd/lib';
import { FileUseCaseInterface } from 'application/usecases/FileUseCase';
import { AttachFileInfo, FileEntity } from 'domain/entities/FileEntity';
import { openErrorNoti, openSuccessNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import UploadImage from './component/Upload';
interface props {
    fileUseCase: FileUseCaseInterface;
}
export const CU06101Page = ({ fileUseCase }: props) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { settlementId } = useParams();
    const [form] = Form.useForm();
    const [initFiles, setInitFiles] = useState<UploadFile[]>([]);
    const [isDisable, setIsDisable] = useState(true);
    useEffect(() => {
        if (settlementId) {
            getFiles();
        }
    }, [settlementId]);
    const submit = async (value: any) => {
        const fileEdits = form.getFieldValue('isEdit') || [];
        if (value.image || fileEdits) {
            const fileList = value?.image?.fileList
                ?.filter((item: any) => {
                    return item.originFileObj;
                })
                .map((item: any) => {
                    return item.originFileObj;
                });

            const payload: FileEntity = {
                files: fileList || [],
                isEdit: JSON.stringify(fileEdits) || '[]',
                settlementId: settlementId || '',
            };
            try {
                dispatch(startFetching());
                const response = await fileUseCase.uploadFileInsurance(payload);
                if (response.status == 200) {
                    openSuccessNoti({ description: '火災保険申込済書の登録が完了しました。' });
                    navigate(-1);
                }
                // getFiles();
                // form.setFieldValue('image', '');
                // form.setFieldValue('isEdit', '');
            } catch (error) {
                openErrorNoti();
            } finally {
                dispatch(completeFetching());
            }
        }
    };
    const getFiles = async () => {
        if (settlementId) {
            try {
                dispatch(startFetching());
                const response = await fileUseCase.getFileInsurances(Number(settlementId));
                const fileInsurance = response?.result;
                const initFiles: UploadFile[] = [];
                if (fileInsurance) {
                    const fileArray = fileInsurance.fileFireInsurance;
                    const mapArray = fileArray.map((item: AttachFileInfo) => {
                        return {
                            uid: item.attachmentFile.id + '',
                            url: item.pathFile,
                            name: item.attachmentFile.fileName,
                            status: 'done',
                        } as UploadFile;
                    });
                    initFiles.push(...mapArray);
                }
                setIsDisable(initFiles.length === 0);
                setInitFiles(initFiles);
            } catch (error) {
                openErrorNoti();
            } finally {
                dispatch(completeFetching());
            }
        }
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
            className="cu-043-01"
        >
            <PageTitle title="火災保険申込済書の登録" showTypeSelect={false} />
            <Form
                className="width-full-screen center-inside CU-001-04-container pr-40"
                style={{
                    height: '100%',
                    overflowY: 'auto',
                }}
                onFinish={submit}
                form={form}
            >
                <div style={{ width: 343 }}>
                    <section style={{ width: '100%', marginBottom: 11 }}>
                        <UploadImage form={form} initFile={initFiles} setIsDisable={setIsDisable} />
                    </section>

                    <Button
                        className="button-login-text"
                        type="primary"
                        style={{ width: '100%', height: 56, letterSpacing: -1.5, marginBottom: 16 }}
                        htmlType="submit"
                        disabled={isDisable}
                    >
                        登録する
                    </Button>
                </div>
            </Form>
        </div>
    );
};
